// ONE "CAR LOCATION" BOX (19 Oct 2026). Robin: "if we have address we dont
// need postcode and house number man, we just need car location field
// right..". While the address lookup is on (ADDRESS_LOOKUP_PROVIDER, the
// layout's gwmc:address-lookup meta), Book & pay asks for one Car location;
// the customer types a street or a postcode and picks their address from the
// list (the lazy address-pick script, components/address-pick). The pick
// fills the postcode and the address the order has always carried.
//
// ONE BOX, ALWAYS (25 Oct 2026). Robin: "you dont need house number any more
// its in the postcode; so postcode should just be 'car location'". "Can't
// find it? Enter it manually", and the page with the lookup switched off,
// keep the same one Car location box as plain free text ("12 Elm Road, SW6
// 1RE"): no list, no separate postcode or house number box. The postcode in
// the text runs the checks the postcode box made (coverage note, Congestion
// Charge tick, the district's days); the order still gets `postcode` (from
// the text) and `address` (the text, which carries the house number).
//
// The main-bundle half, pure (car-location.test.mjs). No em dashes.
import { addressWithPostcode, extractFullPostcode } from './postcode.js'
import { hasHouse } from './address.js'

export const addressLookupOn = () =>
  typeof document !== 'undefined' && document.querySelector('meta[name="gwmc:address-lookup"]')?.getAttribute('content') === 'on'

// What the lazy script tells the page (CustomEvents on document).
export const PICK_EVENT = 'gwmc:car-location'
export const MANUAL_EVENT = 'gwmc:car-location-manual'

// What the box shows once an address is picked: "45 Fulham Road, London, SW6 1RE".
export const pickedLabel = entry => [entry && entry.line, entry && entry.town, entry && entry.postcode].filter(Boolean).join(', ')

// Free text in the box that still books without a pick: a whole postcode and
// something else (the house), e.g. "12 Elm Road SW6 1RE". { postcode,
// address } or null.
export const typedLocation = text => {
  const postcode = extractFullPostcode(text)
  if (!postcode) return null
  const [outward, inward] = postcode.split(' ')
  const address = String(text)
    .replace(new RegExp(`\\b${outward}\\s*${inward}\\b`, 'gi'), ' ')
    .replace(/\s*,(\s*,)+/g, ',')
    .replace(/\s+,/g, ',')
    .replace(/\s{2,}/g, ' ')
    .trim()
    .replace(/^[,\s]+|[,\s]+$/g, '')
  return hasHouse(address) ? { postcode, address } : null
}

export const LOCATION_MESSAGES = {
  missing: 'Add where the car is, e.g. 12 Elm Road',
  not_picked: 'Pick your address from the list, or enter it manually',
  no_postcode: 'Add the postcode so we can check we cover it',
  no_house: 'Add the house number or name, e.g. 12 Elm Road'
}

// Is the box plain free text (no list): the lookup switched off, or the
// customer chose "Enter it manually". lookupOn is addressLookupOn().
export const freeLocation = (values, lookupOn) => !lookupOn || !!(values && values.locationManual)

// The postcode and address the order carries, from what the box holds
// unpicked: the postcode found in the text ('' for none) and the whole text
// (addressWithPostcode puts the postcode on the end once).
export const locationFields = text => ({ postcode: extractFullPostcode(text) || '', address: String(text || '').trim() })

// null when the box gives an address (picked, or typed with its postcode);
// otherwise { reason, message }: 'missing' (empty); with the list,
// 'not_picked'; as free text (free), 'no_postcode' or 'no_house'.
export const locationProblem = (values, free = false) => {
  if (values && values.addressPicked && values.postcode && values.address) return null
  const text = String((values && values.carLocation) || '').trim()
  if (typedLocation(text)) return null
  if (!text) return { reason: 'missing', message: LOCATION_MESSAGES.missing }
  if (!free) return { reason: 'not_picked', message: LOCATION_MESSAGES.not_picked }
  return extractFullPostcode(text)
    ? { reason: 'no_house', message: LOCATION_MESSAGES.no_house }
    : { reason: 'no_postcode', message: LOCATION_MESSAGES.no_postcode }
}

// A draft saved before 25 Oct 2026 by the postcode and house number boxes
// (manual, or the lookup off) has no Car location: its text is the house
// and the postcode joined ("45, SW6 1RE"). Picked drafts keep theirs.
export const draftCarLocation = form => {
  if (!form) return ''
  if (form.carLocation) return form.carLocation
  if (form.addressPicked) return ''
  return addressWithPostcode(form.address, form.postcode)
}
